import type { CSSObject } from '@emotion/react';

import type {
  ThemeType,
} from '@n3/css-base';

export const createSingleValueStyle = ({
  colors,
  select,
}: ThemeType) => (baseCSS: CSSObject, {
  selectProps: {
    isDisabled,
  },
}: {
  selectProps: {
    isDisabled?: boolean;
  };
}): CSSObject => ({
  ...baseCSS,
  color: isDisabled
    ? colors[select.SINGLE_VALUE_TEXT_COLOR_DISABLED]
    : colors[select.SINGLE_VALUE_TEXT_COLOR],
});
